
let globalNavigate = null;
export const setGlobalNavigate = (navigate) => {
    globalNavigate = navigate;
};

export const navigateTo = (path) => {
    if (globalNavigate) {
        globalNavigate(path);
    } else {
        window.location.href = path; 
    }
};
